// Removed dependency on MUI types to avoid tight coupling with MUI

import { Content } from '@/sharedType';

export enum ChatModel {
  GPT_35 = 'GPT_35',
  GPT_35_16K = 'GPT_35_16K',
  GPT_4 = 'GPT_4',
  GPT_4_AZURE = 'GPT_4_AZURE',
  GPT_4_TURBO = 'GPT_4_TURBO',
  GPT_4O = 'GPT_4O',
  GPT_4O_MINI = 'GPT_4O_MINI',
  GPT_4O_2024_08_06 = 'GPT_4O_2024_08_06',
}

export enum AnswersModality {
  TEXT = 'TEXT',
  VOICE = 'VOICE',
  TEXT_AND_VOICE = 'TEXT_AND_VOICE',
}
export enum Role {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
}
export interface Conversation {
  chatId: string;
  createdAt: Date;
  updatedAt: Date;
  messages: Message[];
  username: string;
  metadata?: { [key: string]: unknown };
  extractedData?: { [key: string]: unknown };
}

export interface User {
  canEditDynamicPrompts: boolean;
  canEditDataToExtract: boolean;
  canManageRag: boolean;
  id: string;
  email: string;
  role: Role;
  chats: Pick<ChatMetadata, 'id' | 'name' | 'inputTokens' | 'totalMessages' | 'outputTokens'>[];
}

export interface DynamicSystemPrompt {
  id?: number;
  name: string;
  prompt: string;
  condition: string;
  zIndex: number;
}

export interface PromptVariable {
  id?: number;
  name: string;
  value: string;
  injectToStartOfSystemPrompt: boolean;
  injectToEndOfSystemPrompt: boolean;
  injectToStartOfDynamicPrompt: boolean;
  injectToEndOfDynamicPrompt: boolean;
}

// NOTE: this was generated by prisma
export type ModelVendor = 'OPENAI' | 'GOOGLE';

export interface ModelMetadata {
  id: number;
  name: string;
  displayName: string;
  inputExchangeRate: number;
  outputExchangeRate: number;
  isArchived: boolean;
  vendor: ModelVendor;
  createdAt?: Date;
  updatedAt?: Date;
}

export enum Direction {
  LTR = 'LTR',
  RTL = 'RTL',
}

// TODO: i think there is a mismatch of lower and uppercase. vercel ai need lower case and the DB need upper case
export enum Sender {
  User = 'USER',
  Assistant = 'ASSISTANT',
  Tool = 'TOOL',
}

export interface ExtractedDataField {
  id?: number;
  name: string;
  description: string;
  dataType: DataType;
}

export interface MetadataField extends ExtractedDataField {}

export enum DataType {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  BOOLEAN = 'BOOLEAN',
}

export interface AdminSettings {
  chatId: string | null;
}

export interface ChatMetadata {
  firstMessage: string;
  id: string;
  name: string;
  direction: Direction;
  customUserText?: string;
  customUserBackground?: string;
  textFieldLabel: string;
  isSuggestionsEnabled: boolean;
  isCarouselEnabled: boolean;
  isRefreshPossible: boolean;
  showSources: boolean;
  showCredit: boolean;
  canAcceptMediaMessages: boolean;
  messagesInMemory: number;
  inputTokens: number;
  outputTokens: number;
  totalMessages: number;
  lastMessageNeighbors: number;
  conversationNeighbors: number;
  conversations: [
    {
      messages: Message[];
    },
  ];
  costs?: number | null;
  promptVariables?: PromptVariable[];
  modelMetadata?: ModelMetadata;
  metadataFields?: MetadataField[];
}

export interface Message {
  id?: string;
  createdAt?: string;
  sender: Sender;
  content: Content;
  sources?: Source[];
}

export interface Source {
  title: string;
  url: string;
}

export interface ChatFunction {
  id?: number;
  name?: string;
  description?: string;
  parameters?: string;
  code?: string;
  chatId?: string;
}

export interface UpdateForm {
  airtableLogsBase?: string;
  assistantEmail?: string;
  canAcceptVoiceMessages?: boolean;
  customUserText?: string;
  customUserBackground?: string;
  dataToExtract?: ExtractedDataField[];
  metadataFields?: MetadataField[];
  direction?: Direction;
  dynamicSystemPrompts?: DynamicSystemPrompt[];
  firstMessage?: string;
  functions?: ChatFunction[];
  messagesInMemory?: number;
  model?: ChatModel;
  modelMetadataId?: number;
  name?: string;
  openaiKey?: string;
  googleKey?: string;
  promptVariables?: PromptVariable[];
  sendgridApiKey?: string;
  isSuggestionsEnabled?: boolean;
  isCarouselEnabled?: boolean;
  isRefreshPossible?: boolean;
  usesDurableMediaLinks?: boolean;
  sharesMediaUrlsWithModel?: boolean;
  showSources?: boolean;
  systemPrompt?: string;
  temperature?: number;
  textFieldLabel?: string;
  ttsPrompt?: string;
  twilioAccountSid?: string;
  twilioAuthToken?: string;
  twilioMessagingServiceSid?: string;
  whatsappPrompt?: string;
  answersModality?: AnswersModality;
  costLimit?: number;
  lastMessageNeighbors?: number;
  conversationNeighbors?: number;
}

export type SourceType = 'URL' | 'TEXT' | 'WEBSITE';
export type Frequency = 'NONE' | 'ONE_TIME' | 'DAILY' | 'WEEKLY';
export type MatcherType = 'REGEX' | 'CSS_SELECTOR' | 'CSS_SELECTOR_AS_MARKDOWN_CLEAN';

export interface Matcher {
  id: number;
  sourceDefinitionId: number;
  type: MatcherType;
  valueFrom: string;
}

export interface SourceDefinition {
  id: number;
  chatId: string;
  type: SourceType;
  url: string | null;
  linkSelector: string | null;
  frequency: Frequency;
  chunkSize: number;
  chunksOverlap: number;
  splitDelimiter?: string | null;
  lastRun: string | null;
  matchers: Matcher[];
}

export interface RagDocument {
  id: number;
  createdAt: string;
  updatedAt: string;
  url: string;
  title: string;
  content: string;
  sourceDefinitionId: number | null;
}
